import React from 'react';
import { Theme, makeStyles } from '@material-ui/core';
import BaseChip, { ChipProps } from '@material-ui/core/Chip';
import { PaletteColor } from '@material-ui/core/styles/createPalette';
import { StyledText } from './StyledText';


interface EmailChipStylesProps {
  valid: boolean
}

const useStyles = makeStyles<Theme, EmailChipStylesProps>((theme: Theme) => {
  const colorForValidState: (valid: boolean) => PaletteColor = (valid) => {
    if (valid) {
      return theme.palette.primary;
    } else {
      return theme.palette.error;
    }
  };
  return ({
    root: ({ valid }) => ({
      height: 25,
      backgroundColor: colorForValidState(valid).light,
      color: '#000000',
      border: `solid 1px ${colorForValidState(valid).main}`,
      '&:hover': {
        // backgroundColor: colorForStatus(status).main
        // design should define this, cant tell from figma and default looks not great
      },
      '& .MuiChip-deleteIcon': {
        color: colorForValidState(valid).main
      },
      '&:hover .MuiChip-deleteIcon': {
        // color: colorForStatus(status).light
      }
    })
  });
});

interface EmailChipProps extends ChipProps {
  title: string
  valid: boolean
}

const EmailChip: React.FC<EmailChipProps> = ({
  title,
  valid,
  ...restProps
}) => {
  const styles = useStyles({ valid });
  return (
    <BaseChip
      classes={styles}
      label={(<StyledText variant='statusChip'>{title}</StyledText>)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    />
  );
};

export default EmailChip;
